/* eslint-disable */
import axios from 'axios';
import { t } from "i18next";
import { SubmissionError } from "redux-form"
import { endpoints } from '../../utils/constants';
import { getAddress, getZip, getCity, getState, getCountry, downloadFile } from '../../utils/func';
import { digitOnly } from '../../utils/mask'
import { parseAttachedDocuments } from '../../utils/uploadedFiles';
import handleDeliveryType from '../../utils/deliveryAddress';
import { DeliveryTypes, QuoteTypes, PaymentMethods, SamedayServiceType, PrefillNumberTypes, BillToMethods, SamedayShipmentType } from '../../utils/enums';
import { accessorialsLists, measurementLists } from '../../utils/orders';

export const getAccessorials = ({ isAuthenticated, division, updateState, USQuote, billTo }) => {
  return axios.get(`${t("ApiEndPoint")}${t('ShippingApiVirtualFolder')}${endpoints.shipping.accessorials}/${division}${USQuote ? '/customer' : ''}`,
    {
      headers: {
        accountNumber: isAuthenticated ? billTo : '999998'
      }
    }).then(res => {
      if (res.status === 200) {
        updateState('accList', res.data)
      }
    })
}

export const getServiceQuotes = ({ putReduxServiceLevelQuotes, putReduxServiceLevelCode, formData, prevStep }) => {
  const {
    deliveryType,
    division,
    paymentMethod,
    shipperContactName,
    shipperCompanyName,
    shipperAddress,
    shipperAddressAdditional,
    shipperEmail,
    shipperPhoneNumber,
    shipperPhoneNumberExt,
    consigneeAddressAdditional,
    consigneeEmail,
    consigneePhoneNumber,
    consigneeAddress,
    consigneeContactName,
    consigneeCompanyName,
    consigneePhoneNumberExt,
    measurementType,
    measurementList,
    accessorials,
    quoteDest,
    billTo,
    numberTypeSelected,
    quoteOrShipmentNumber
  } = formData

  const shipperAddress1 = getAddress(shipperAddress)
  const shipperCity = getCity(shipperAddress)
  const shipperState = getState(shipperAddress)
  const shipperZip = getZip(shipperAddress)
  const shipperCountry = getCountry(shipperAddress)

  const consigneeAddress1 = getAddress(consigneeAddress)
  const consigneeCity = getCity(consigneeAddress)
  const consigneeState = getState(consigneeAddress)
  const consigneeZip = getZip(consigneeAddress)
  const consigneeCountry = getCountry(consigneeAddress)

  const formValueToApi = {
    sourceType: "CS",
    serviceType: deliveryType.name === DeliveryTypes.Residential ? SamedayServiceType.Residential : SamedayServiceType.Commercial,
    paymentType: paymentMethod.split(' ').join(''),
    language: 'EN',
    division: division || 'Sameday',
    requestor: {
      companyName: shipperCompanyName,
      contactName: shipperContactName,
      address1: shipperAddress1,
      address2: shipperAddressAdditional,
      city: shipperCity,
      provinceCode: shipperState,
      countryCode: shipperCountry,
      postalCode: shipperZip,
      contactPhoneNumber: digitOnly(shipperPhoneNumber),
      contactPhoneNumberExt: shipperPhoneNumberExt,
      contactEmail: quoteDest
    },
    from: {
      companyName: shipperCompanyName,
      contactName: shipperContactName,
      address1: shipperAddress1,
      address2: shipperAddressAdditional,
      city: shipperCity,
      provinceCode: shipperState,
      countryCode: shipperCountry,
      postalCode: shipperZip,
      contactPhoneNumber: digitOnly(shipperPhoneNumber),
      contactPhoneNumberExt: shipperPhoneNumberExt,
      contactEmail: shipperEmail
    },
    to: {
      companyName: consigneeCompanyName,
      contactName: consigneeContactName,
      address1: consigneeAddress1,
      address2: consigneeAddressAdditional,
      city: consigneeCity,
      provinceCode: consigneeState,
      countryCode: consigneeCountry,
      postalCode: consigneeZip,
      contactPhoneNumber: digitOnly(consigneePhoneNumber),
      contactPhoneNumberExt: consigneePhoneNumberExt,
      contactEmail: consigneeEmail
    },
    shipmentItems: measurementLists(measurementList, measurementType.value),
    accessorials: accessorialsLists(accessorials),
    accountNumber: billTo,
    measurementType: measurementType.value,
    quoteNumber: numberTypeSelected.value === PrefillNumberTypes.quote ? quoteOrShipmentNumber : undefined
  }

  return axios.post(`${t("ApiEndPoint")}${t('ShippingApiVirtualFolder')}${endpoints.shipping.serviceLevel}`, formValueToApi).then(res => {
    if (res.status === 200) {
      console.log(res)
      putReduxServiceLevelQuotes(res.data.serviceLevels)
      putReduxServiceLevelCode(handleDeliveryType(deliveryType, res))
    }
    console.log(res)
  }).catch(err => {
    prevStep()
  })
}

export const submitShipment = ({ serviceLevelCode, formData, updateState, prevStep }) => {
  const {
    deliveryType,
    division,
    paymentMethod,
    shipperContactName,
    shipperCompanyName,
    shipperAddress,
    shipperAddressAdditional,
    shipperEmail,
    shipperPhoneNumber,
    shipperPhoneNumberExt,
    shipperMobileSMSNotification,
    consigneeAddressAdditional,
    consigneeEmail,
    consigneePhoneNumber,
    consigneeAddress,
    consigneeContactName,
    consigneeCompanyName,
    consigneePhoneNumberExt,
    consigneeMobileSMSNotification,
    measurementType,
    measurementList,
    accessorials,
    quoteDest,
    pickupDate,
    emergencyPhone,
    erapReference,
    erapPhone,
    dgContactName,
    referenceNumber,
    poNumber,
    specialInstructions,
    readyTime,
    closingTime,
    shipmentType,
    accessByTrailer,
    droppingFreightOff,
    regularScheduledPickup,
    attachedDocuments,
    billingAddressAdditional,
    billingEmail,
    billingPhoneNumber,
    billingAddress,
    billingContactName,
    billingCompanyName,
    billingPhoneNumberExt,
    gstNumber,
  } = formData

  const shipperAddress1 = getAddress(shipperAddress)
  const shipperCity = getCity(shipperAddress)
  const shipperState = getState(shipperAddress)
  const shipperZip = getZip(shipperAddress)
  const shipperCountry = getCountry(shipperAddress)

  const consigneeAddress1 = getAddress(consigneeAddress)
  const consigneeCity = getCity(consigneeAddress)
  const consigneeState = getState(consigneeAddress)
  const consigneeZip = getZip(consigneeAddress)
  const consigneeCountry = getCountry(consigneeAddress)

  const formValueToApi = {
    serviceLevelCode: serviceLevelCode,
    serviceType: deliveryType.name === DeliveryTypes.Residential ? SamedayServiceType.Residential : SamedayServiceType.Commercial,
    paymentType: paymentMethod.split(' ').join(''),
    language: 'EN',
    shipmentType: shipmentType ? shipmentType : SamedayShipmentType.Regular,
    division: division,
    from: {
      companyName: shipperCompanyName,
      contactName: shipperContactName,
      address1: shipperAddress1,
      address2: shipperAddressAdditional,
      city: shipperCity,
      provinceCode: shipperState,
      countryCode: shipperCountry,
      postalCode: shipperZip,
      contactPhoneNumber: digitOnly(shipperPhoneNumber),
      contactPhoneNumberExt: shipperPhoneNumberExt,
      cellNumber: shipperMobileSMSNotification,
      contactEmail: shipperEmail
    },
    to: {
      companyName: consigneeCompanyName,
      contactName: consigneeContactName,
      address1: consigneeAddress1,
      address2: consigneeAddressAdditional,
      city: consigneeCity,
      provinceCode: consigneeState,
      countryCode: consigneeCountry,
      postalCode: consigneeZip,
      contactPhoneNumber: digitOnly(consigneePhoneNumber),
      contactPhoneNumberExt: consigneePhoneNumberExt,
      cellNumber: consigneeMobileSMSNotification,
      contactEmail: consigneeEmail
    },
    thirdPartyDetails: paymentMethod === PaymentMethods.ThirdParty ? {
      companyName: billingCompanyName,
      contactName: billingContactName,
      address1: getAddress(billingAddress),
      address2: billingAddressAdditional,
      city: getCity(billingAddress),
      provinceCode: getState(billingAddress),
      countryCode: getCountry(billingAddress),
      postalCode: getZip(billingAddress),
      contactPhoneNumber: digitOnly(billingPhoneNumber),
      contactPhoneNumberExt: billingPhoneNumberExt,
      contactEmail: billingEmail
    } : undefined,
    gstNumber,
    shipmentItems: measurementLists(measurementList, measurementType.value, false),
    accessorials: accessorialsLists(accessorials),
    confirmationEmail: quoteDest,
    measurementType: measurementType.value,
    specialInstructions,
    isAllowAccessByTrailer: accessByTrailer.value,
    droppingFreightOff: droppingFreightOff.value,
    hasRegularPickups: regularScheduledPickup.value,
    pickupDetails: {
      pickupDate,
      readyTime: `${readyTime.hours.length < 2 ? '0' + readyTime.hours : readyTime.hours}:${readyTime.minutes.length < 2 ? '0' + readyTime.minutes : readyTime.minutes} ${readyTime.amOrPm}`,
      closingTime: `${closingTime.hours.length < 2 ? '0' + closingTime.hours : closingTime.hours}:${closingTime.minutes.length < 2 ? '0' + closingTime.minutes : closingTime.minutes} ${closingTime.amOrPm}`,
    },
    referenceNumber,
    poNumber,
    emergencyPhoneNumber: emergencyPhone ? digitOnly(emergencyPhone) : emergencyPhone,
    erapReferenceNumber: erapReference,
    erapPhoneNumber: erapPhone ? digitOnly(erapPhone) : erapPhone,
    contactName: dgContactName || '',
  }

  parseAttachedDocuments(attachedDocuments, formValueToApi);

  return axios.post(`${t("ApiEndPoint")}${t('ShippingApiVirtualFolder')}${endpoints.shipping.shipments}`, formValueToApi).then(res => {
    if (res.status === 200 || res.status === 201) {
      updateState('data', {
        probillNumber: res.data.probillNumber,
        orderNumber: res.data.orderId,
      })
      window.scrollTo(0, 0);
    }
  }).catch(() => {
    throw new SubmissionError({})
  })
}

export const cancelOrder = (shipperZip, orderNumber) => {
  const formValueToApi = {
    orderId: Number(orderNumber),
    zone: shipperZip,
  }

  return axios.post(`${t("ApiEndPoint")}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.manageOrders.cancel}`, formValueToApi).then(res => {
    if (res.status === 200 || res.status === 201) {
      window.scrollTo(0, 0);
      return {
        hasReturnedError: false,
        message: t('CancelSuccessMessage'),
      };
    }
  }).catch(() => {
    return {
      hasReturnedError: true,
      message: t('CancelErrorMessage'),
    };
  });
}

export const formDataToApi = (formData, userId, serviceLvlCode, userEmail) => {
  const {
    quoteType,
    usFromAddress,
    usToAddress,
    deliveryType,
    division,
    paymentMethod,
    shipperContactName,
    shipperCompanyName,
    shipperAddress,
    shipperAddressAdditional,
    shipperEmail,
    shipperPhoneNumber,
    shipperPhoneNumberExt,
    shipperMobileSMSNotification,
    consigneeAddressAdditional,
    consigneeEmail,
    consigneePhoneNumber,
    consigneeAddress,
    consigneeContactName,
    consigneeCompanyName,
    consigneePhoneNumberExt,
    consigneeMobileSMSNotification,
    measurementType,
    measurementList,
    accessorials,
    quoteDest,
    tariffSurcharge,
    billTo,
    shipmentType = SamedayShipmentType.Regular,
    USShipment,
    pickupDate,
    readyTime,
    closingTime,
    accessByTrailer,
    sendConsigneeInfo,
    droppingFreightOff,
    regularScheduledPickup,
    attachedDocuments,
    billingAddressAdditional,
    billingEmail,
    billingPhoneNumber,
    billingAddress,
    billingContactName,
    billingCompanyName,
    billingPhoneNumberExt,
    gstNumber,
    thirdPartyAccountNumber,
    referenceNumber,
    poNumber,
    specialInstructions,
    emergencyPhone,
    erapReference,
    erapPhone,
    dgContactName,
    shipmentId,
    numberTypeSelected,
    quoteOrShipmentNumber,
    billToMethod
  } = formData;

  const USQuote = quoteType && quoteType.name === QuoteTypes.USQuote;

  let shipperAddress1;
  let shipperCity;
  let shipperState;
  let shipperZip;
  let shipperCountry;

  let consigneeAddress1;
  let consigneeCity;
  let consigneeState;
  let consigneeZip;
  let consigneeCountry;

  if (USQuote) {
    shipperCity = usFromAddress.cityName;
    shipperState = usFromAddress.provinceCode;
    shipperZip = usFromAddress.postalCode;
    shipperCountry = usFromAddress.countryCode;

    consigneeCity = usToAddress.cityName;
    consigneeState = usToAddress.provinceCode;
    consigneeZip = usToAddress.postalCode;
    consigneeCountry = usToAddress.countryCode;
  } else {
    shipperAddress1 = getAddress(shipperAddress);
    shipperCity = getCity(shipperAddress);
    shipperState = getState(shipperAddress);
    shipperZip = getZip(shipperAddress);
    shipperCountry = getCountry(shipperAddress);

    consigneeAddress1 = getAddress(consigneeAddress);
    consigneeCity = getCity(consigneeAddress);
    consigneeState = getState(consigneeAddress);
    consigneeZip = getZip(consigneeAddress);
    consigneeCountry = getCountry(consigneeAddress);
  }

  const formValueToApi = {
    shipmentId: shipmentId,
    confirmationEmail: quoteDest,
    measurementType: measurementType.value,
    // userId: userId,
    userId: +userId,
    serviceLevelCode: serviceLvlCode,
    serviceType: deliveryType.name === DeliveryTypes.Residential ? SamedayServiceType.Residential : SamedayServiceType.Commercial,
    paymentType: paymentMethod.split(" ").join(""),
    language: "EN",
    accountNumber: billToMethod !== BillToMethods.enterBillTo ? billTo : thirdPartyAccountNumber,
    createByUserId: userId,
    createByUserEmail: userEmail,
    sendEmailToConsignee: sendConsigneeInfo,
    division: division || 'Sameday',
    discountPercentage:
      tariffSurcharge && tariffSurcharge.discountPercentage
        ? tariffSurcharge.discountPercentage
        : undefined,
    minimumRateAmount:
      tariffSurcharge &&
        tariffSurcharge.minimumRateAmount &&
        tariffSurcharge.minimumRateAmount.value
        ? tariffSurcharge.minimumRateAmount.value
        : undefined,
    requestor: {
      companyName: shipperCompanyName,
      contactName: shipperContactName,
      address1: shipperAddress1,
      address2: shipperAddressAdditional,
      city: shipperCity,
      provinceCode: shipperState,
      countryCode: shipperCountry,
      postalCode: shipperZip,
      contactPhoneNumber: digitOnly(shipperPhoneNumber),
      contactPhoneNumberExt: shipperPhoneNumberExt,
      cellNumber: shipperMobileSMSNotification,
      contactEmail: quoteDest
    },
    from: {
      companyName: shipperCompanyName,
      contactName: shipperContactName,
      address1: shipperAddress1,
      address2: shipperAddressAdditional,
      city: shipperCity,
      provinceCode: shipperState,
      countryCode: shipperCountry,
      postalCode: shipperZip,
      contactPhoneNumber: digitOnly(shipperPhoneNumber),
      contactPhoneNumberExt: shipperPhoneNumberExt,
      cellNumber: shipperMobileSMSNotification,
      contactEmail: shipperEmail
    },
    to: {
      companyName: consigneeCompanyName,
      contactName: consigneeContactName,
      address1: consigneeAddress1,
      address2: consigneeAddressAdditional,
      city: consigneeCity,
      provinceCode: consigneeState,
      countryCode: consigneeCountry,
      postalCode: consigneeZip,
      contactPhoneNumber: digitOnly(consigneePhoneNumber),
      contactPhoneNumberExt: consigneePhoneNumberExt,
      cellNumber: consigneeMobileSMSNotification,
      contactEmail: consigneeEmail
    },
    thirdPartyDetails: paymentMethod.name === PaymentMethods.ThirdParty && billToMethod !== BillToMethods.pickBillTo ? {
      companyName: billingCompanyName,
      contactName: billingContactName,
      address1: getAddress(billingAddress),
      address2: billingAddressAdditional,
      city: getCity(billingAddress),
      provinceCode: getState(billingAddress),
      countryCode: getCountry(billingAddress),
      postalCode: getZip(billingAddress),
      contactPhoneNumber: digitOnly(billingPhoneNumber),
      contactPhoneNumberExt: billingPhoneNumberExt,
      contactEmail: billingEmail
    } : undefined,
    thirdPartyAccountNumber,
    gstNumber,
    shipmentItems: measurementLists(measurementList, measurementType.value, false),
    accessorials: accessorialsLists(accessorials),
    shipmentType: shipmentType,
    USShipment,
    isAllowAccessByTrailer: accessByTrailer.value,
    droppingFreightOff: droppingFreightOff.value,
    hasRegularPickups: regularScheduledPickup.value,
    pickupDetails: regularScheduledPickup.value ? undefined : {
      pickupDate,
      readyTime: `${readyTime.hours.length < 2 ? '0' + readyTime.hours : readyTime.hours}:${readyTime.minutes.length < 2 ? '0' + readyTime.minutes : readyTime.minutes} ${readyTime.amOrPm}`,
      closingTime: `${closingTime.hours.length < 2 ? '0' + closingTime.hours : closingTime.hours}:${closingTime.minutes.length < 2 ? '0' + closingTime.minutes : closingTime.minutes} ${closingTime.amOrPm}`,
    },
    specialInstructions: specialInstructions,
    referenceNumber: referenceNumber,
    poNumber: poNumber,
    emergencyPhoneNumber: emergencyPhone ? digitOnly(emergencyPhone) : emergencyPhone,
    erapReferenceNumber: erapReference,
    erapPhoneNumber: erapPhone ? digitOnly(erapPhone) : erapPhone,
    contactName: dgContactName || '',
    quoteNumber: numberTypeSelected.value === PrefillNumberTypes.quote ? quoteOrShipmentNumber : undefined
  };

  parseAttachedDocuments(attachedDocuments, formValueToApi);

  return formValueToApi;
};

export const BOLcall = ({ probillNumber, division, emailAddress, userId }) => {
  axios.get(`${t("ApiEndPoint")}${t('ShippingApiVirtualFolder')}${endpoints.shipping.shipmentDocuments}/${division}/${probillNumber}/bol`, {
    params: {
      emailAddress,
      userId
    },
  }).then(res => {
    if (res.status === 200) {
      downloadFile({ dataAsBase64: res.data.fileDataAsBase64, mimeType: res.data.mimeType, filename: res.data.fileName });
    }
  })
    .catch(error => {
      if (error) {
        console.log('error is', error);
      }
    })
}